import axios from "axios";
import * as Constants from "../constant";
const editIsDraft = async (id,IsDraft) => {
	try {
		const response = await axios.patch(
			`${Constants?.LOCAL_URL}/space/Isdraft/${id}`,IsDraft
		);
		return response;
	} catch (error) {
		return error;
	}
};
export default editIsDraft;
